/* ==========================================================================
   AMADA 通用商品卡交互 —— 色块点击换图（2026-09-03 运营验收 Q5）
   ==========================================================================
   需求原文：
     「色块用商品变体的原生色卡图/色值（与商品图一致），**点击切换卡片主图到对应
       颜色变体的图片**（无图的颜色降级不切），卡片链接带 ?variant=；
       当前色块点击无反应。」

   为什么单独一个 js 文件而不是塞进 amada-collection.js：
   同一张卡（snippets/amada-product-card.liquid）被分类页、sale 页、搜索页共用，
   而 amada-collection.js 只在分类页 section 里加载 —— 塞进去的话搜索页的色块
   照样点不动。本文件由**渲染卡片的 section** 各自引一次（分类页 / 搜索页），
   多次加载靠下面的 window 标记幂等，不会重复绑定。

   规格来源：色块本身 17:7199（16×16 盒 + 内 12×12 + 选中 0.5 描边），
   本文件不碰任何尺寸，只管行为。

   🚨 契约（改属性名会直接失效，snippets/amada-product-card.liquid 那侧同名）：
     button[data-amada-swatch]  data-variant-id  data-variant-image
     article[data-amada-card]   data-product-url
   ========================================================================== */
(function () {
  'use strict';

  /* 幂等：两个 section 同页出现（例如 sale 页的横幅 + 网格未来若都引）时只绑一次。
     用 window 标记而不是 module 作用域 —— 同一个 URL 的 <script> 被写两遍时
     浏览器会各执行一次，模块内的变量不共享。 */
  if (window.__amadaCardBound) return;
  window.__amadaCardBound = true;

  /* 把 ?variant= 拼到商品链接上。
     用 URL 解析而不是字符串拼 '?variant=' —— 商品链接本身可能已经带了
     ?variant=（从 PDP 回来的卡片）或 ?_pos=&_sid= 这类 Shopify 追踪参数，
     裸拼会拼出两个 ? 或两个 variant。 */
  function withVariant(baseUrl, variantId) {
    if (!baseUrl) return baseUrl;
    try {
      var u = new URL(baseUrl, window.location.origin);
      if (variantId) {
        u.searchParams.set('variant', variantId);
      } else {
        u.searchParams.delete('variant');
      }
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return baseUrl;
    }
  }

  function selectSwatch(btn) {
    var card = btn.closest('[data-amada-card]');
    if (!card) return;

    /* ① 选中态：同卡片内互斥 */
    var all = card.querySelectorAll('[data-amada-swatch]');
    for (var i = 0; i < all.length; i++) {
      var on = all[i] === btn;
      all[i].classList.toggle('is-selected', on);
      all[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    var variantId = btn.getAttribute('data-variant-id') || '';
    var variantImage = btn.getAttribute('data-variant-image') || '';

    /* ② 主图：只有这个颜色**真的有变体主图**时才换。
       运营口径「无图的颜色降级不切」—— 没图就保持当前主图，
       绝不换成占位图或空白（那比不换更像 bug）。
       必须先摘掉 srcset/sizes：<img> 上只要还有 srcset，浏览器就按 srcset 选源，
       改 src 完全没效果（表现成「点了没反应」，很容易误判成事件没绑上）。 */
    if (variantImage) {
      var img = card.querySelector('.amada-card__img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', variantImage);
      }
    }

    /* ③ 卡片链接带上 ?variant=：标题链接与图片链接都要，
       否则用户点图进去看到的还是默认颜色。 */
    if (variantId) {
      var base = card.getAttribute('data-product-url');
      var href = withVariant(base, variantId);
      var links = card.querySelectorAll('.amada-card__title, .amada-card__media-link');
      for (var j = 0; j < links.length; j++) links[j].setAttribute('href', href);

      /* ④ 心形的收藏契约按变体存储（assets/amada-favorites.js 的 data-variant-id），
         换了颜色不同步的话，收藏进去的还是第一个变体。 */
      var heart = card.querySelector('[data-favorites-toggle]');
      if (heart) heart.setAttribute('data-variant-id', variantId);
    }
  }

  /* 捕获阶段委托：主题自己也在 document 上监听 click，冒泡阶段会被它抢先
     （PDP Size Guide 那次实证）。卡片是 SEE MORE AJAX 追加进来的，
     必须走 document 委托，逐元素绑定必漏。 */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-amada-swatch]');
      if (!btn) return;
      e.preventDefault();
      selectSwatch(btn);
    },
    true
  );
})();
